import type { CSSProperties } from 'react';
import { UhcMediumHeader } from '@src/apps/styles/common-style';

export const profileDropdownStyles: { [key: string]: CSSProperties } = {
  userWrap: {
    position: 'relative',
    height: '100%',
    display: 'flex',
    alignItems: 'center'
  },
  userRow: {
    height: '100%',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#757588',
    fontFamily: 'UHCSans-SemiBold, Helvetica, Arial, Verdana, Tahoma, sans-serif',
    letterSpacing: '0.2px',
    padding: '9px 12px',
    cursor: 'pointer',
    gap: '4px',
    boxSizing: 'border-box',
    whiteSpace: 'nowrap'
  },
  userIconWrap: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    height: '24px',
    lineHeight: 0,
    flexShrink: 0
  },
  userName: {
    fontFamily: UhcMediumHeader,
    display: 'inline-flex',
    alignItems: 'center',
    lineHeight: '24px'
  },
  userMenu: {
    position: 'absolute',
    right: '0px',
    top: '60px',
    minWidth: '225px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
    borderRadius: '3px 3px 0 0',
    backgroundColor: '#ffffff',
    color: '#757588',
    zIndex: 1001
  },
  userDetails: {
    padding: '12px 14px'
  },
  profileName: {
    margin: 0,
    fontFamily: 'UHCSans-SemiBold, Helvetica, Arial, Verdana, Tahoma, sans-serif',
    color: '#2d2d39'
  },
  profileText: {
    margin: 0,
    fontSize: '14px',
    lineHeight: '20px'
  },
  dropdownRow: {
    borderTop: '1px solid #e0e0e0',
    padding: '8px 14px',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
  },
  dropdownText: {
    color: '#757588',
    fontFamily: 'UHCSans-Medium, Helvetica, Arial, Verdana, Tahoma, sans-serif',
    fontSize: '16px',
    letterSpacing: '0.2px',
    lineHeight: '22px'
  },
  buttonReset: {
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    width: '100%',
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: 0
  }
};